// Setup any WS feeds for this page
let ws = null;

export function subscribeWS(channels, handler) {
    if (channels.length === 0) {
        return;
    }
    closeWS();

    ws = new WebSocket('ws://' + window.location.host + '/websocket/ws');
    ws.onopen = () => {
        for (let i=0; i<channels.length; i++) {
            ws.send("{ \"channel\" : \"" + channels[i] + "\"}");
        }
    }
    ws.onclose = () => {
        ws = null;
    }
    ws.onerror = (error) => {
        ws = null
    }
    ws.onmessage = function (event) {
        let msg = JSON.parse(event.data);
        handler(msg);
    };
}

export function resetWS() {
    closeWS();
}

function closeWS() {
    if (!ws) {
        return;
    }
    ws.onopen = null;
    ws.onclose = null;
    ws.onerror = null;
    ws.onmessage = null;
    ws.close();
    ws = null;
}
